export default __webpack_public_path__ + "static/media/BLUECHECK.2cdaadf9.png";